<template>
  <div class="user-search-results-container">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'UserSearchResultsContainer',
  };
</script>

<style scoped>
  .user-search-results-container {
    padding: 12px 0;
  }
</style>
